/**
 * SectionBg — reusable PDF-image parallax background for each section.
 * Renders the image at a tuned opacity with a vertical dark gradient overlay
 * so headings & cards stay readable while the imagery still pops.
 */
export default function SectionBg({
    src,
    opacity = 0.6,
    overlay = "from-[#0a0a0a]/88 via-[#0a0a0a]/64 to-[#0a0a0a]/94",
    position = "center",
    blur = false,
}) {
    return (
        <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden>
            <img
                src={src}
                alt=""
                loading="lazy"
                className={`absolute inset-0 w-full h-full object-cover ${blur ? "blur-[2px]" : ""}`}
                style={{ opacity, objectPosition: position }}
            />
            <div className={`absolute inset-0 bg-gradient-to-b ${overlay}`} />
            <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[#0a0a0a] to-transparent" />
            <div className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-t from-[#0a0a0a] to-transparent" />
        </div>
    );
}
